import { memo } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { CenteredStack } from "../../layout/CenteredStack";
import { Subtitle } from "../../data-display/Subtitle";

export interface LoadingModalProps {
  open: boolean;
  /** Optional status line shown beneath the spinner. */
  message?: string;
}

/**
 * Non-dismissible blocking dialog shown during in-progress server calls.
 * Pair with useLoadingModal for imperative control, or pass open={saving} directly.
 */
export const LoadingModal = memo(function LoadingModal({ open, message }: LoadingModalProps) {
  return (
    <Dialog open={open} onClose={undefined} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogContent>
        <CenteredStack gap={2} $minHeight={120}>
          <CircularProgress />
          {message ? <Subtitle>{message}</Subtitle> : null}
        </CenteredStack>
      </DialogContent>
    </Dialog>
  );
});
